import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { AuthService, UserType } from '@instaclause-webapp/shared-core';

/**
 * A support session is a BackOffice user without an office of their own — the same rule the
 * backend applies in `IsSupportAdmin` before scoping contracts to active support grants. A
 * BackOffice user that does belong to an office is an ordinary office user here, and must not
 * be told they are in support mode.
 */
@Injectable({ providedIn: 'root' })
export class SupportModeService {
  /** Office-scoped areas are hidden for whoever has no office, whatever their user type. */
  readonly hasOffice = computed(() => (this.user()?.customerId ?? null) !== null);

  readonly isSupport = computed(
    () => this.user()?.userType === UserType.BackOffice && !this.hasOffice(),
  );

  private readonly user = toSignal(inject(AuthService).user$, { initialValue: null });
}
